import { Progress, Tooltip, enums, utils as u } from 'edrolo-ui';
import { ButtonLinkProps } from 'edrolo-ui/components/Button';
import { useContext } from 'react';
import { ClassContext, UserContext } from 'edrolo/context';
import { useUserCourseProgress } from 'edrolo/domains/bySchoolClass';
import { Link } from 'react-router-dom';
import { Exam } from '../../../../../../../types/Assemblage';

interface Props {
  url: ButtonLinkProps['to'];
  questionSet: Exam;
}
export const StudentProgress = ({
  questionSet,
  url,
}: Props): JSX.Element | null => {
  const {
    data: { classId },
  } = useContext(ClassContext);

  const { profile } = useContext(UserContext);

  const { data, loading, error } = useUserCourseProgress(
    profile.user_id,
    classId
  );

  if (loading || error) {
    return null;
  }

  const responseCount = data.exams[questionSet.id]?.response_count || 0;

  return (
    <Tooltip
      tip={`You have completed ${responseCount} out of ${questionSet.question_count} questions`}
    >
      <Link to={url}>
        <Progress.Circle
          numerator={responseCount}
          denominator={questionSet.question_count}
          size={enums.Size.LARGE}
          className={u.hiddenSmallOnly}
        />
      </Link>
    </Tooltip>
  );
};
